/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resetPastAttemptsByFactor} from '../api'

export const useMutationResetPastAttemptsByFactor = createReactQueryMutationHook('resetPastAttemptsByFactor', resetPastAttemptsByFactor)
